export default __webpack_public_path__ + "static/media/CovidInfo.95788e50.svg";